<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs4-06",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 58,
      nextPage: '/questionnaire/section4/7',
      navigateType: 'CLICK_NEXT',
      content: {
        layout: 'layout_left',
        componentsType: {
          pc: 'labelBtn',
          mobile: 'labelBtn'
        },
        mainTitle: 'Are you taking any of the following medications?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Antibiotics',
            },{
              text: 'Antidepressants',
            },{
              text: 'Decongestants',
            }
          ],[
            {
              text: 'Hormonal\ncontraceptives',
            },{
              text: 'Non-inflammatory\ndrugs',
            },{
              text: 'Diuretics',
            }
          ],[
            {
              text: 'None',
              unique: true
            }
          ]
        ],
        hasInput: true
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
